import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext(null);
const KEY = 'gaaf_user_profile';

export function UserProvider({ children }) {
    const [profile, setProfile] = useState({ name: '', phone: '', email: '' });
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const raw = localStorage.getItem(KEY);
        if (raw) { try { setProfile(JSON.parse(raw)); } catch { } }
        setReady(true);
    }, []);

    const updateProfile = (updates) => {
        const merged = { ...profile, ...updates };
        setProfile(merged);
        localStorage.setItem(KEY, JSON.stringify(merged));
        return merged;
    };

    const clearProfile = () => {
        localStorage.removeItem(KEY);
        setProfile({ name: '', phone: '', email: '' });
    };

    return (
        <UserContext.Provider value={{ profile, ready, updateProfile, clearProfile }}>
            {children}
        </UserContext.Provider>
    );
}

export const useUser = () => useContext(UserContext);
